/**
 * Coupon / VIP codes are stored uppercase in the backend (`coupon.code`) and the
 * MySQL lookup is case-insensitive, so "kesa2026", "Kesa2026 " and "KESA2026" all
 * validate — but they reach GA4 as three different `coupon` values and split the
 * campaign in reporting.
 *
 * Normalise at every entry point (typed input, URL `?code=` / `?vip=`, profile
 * auto-apply) so one code is one string everywhere: UI, API calls and analytics.
 */
export function normalizeCouponCode(code: string | null | undefined): string {
  return (code ?? '').trim().toUpperCase();
}
